import {Flex, useMediaQuery} from "@chakra-ui/react";
import Sidebar from "../../pages/Sidebar";
import Page from "./Page";
import MobileSidebar from "./MobileSideBar";
import {NavProvider} from "../../context";


function Layout({children}: any) {
    const [isDesktop] = useMediaQuery(`(min-width: 768px)`);
    return <NavProvider>
        <Flex h="100dvb" gap={{md: ".5rem", lg: "1.5rem", xl: "2.5rem"}}>
            {isDesktop
                ? <Sidebar/>
                : <MobileSidebar/>
            }
            <Page>{children}</Page>
        </Flex>
    </NavProvider>;
}

export default Layout;
